import { Link } from 'react-router-dom';
import { mangaCategories } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="text-2xl font-bold text-accent-500">YY</span>
              <span className="text-lg font-semibold text-foreground-950">漫画网</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              YY漫画网提供韩漫、日漫、国漫等分类大全，好看的漫画排行榜推荐，免费漫画分类浏览，全集漫画免费下拉式阅读。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">漫画分类</h4>
            <div className="flex flex-col gap-2">
              {mangaCategories.slice(1, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className="text-sm text-foreground-600 hover:text-accent-500 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门推荐</h4>
            <div className="flex flex-col gap-2">
              <Link to="/manga/manga-5" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors">
                斗破苍穹
              </Link>
              <Link to="/manga/manga-3" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors">
                咒术回战
              </Link>
              <Link to="/manga/manga-8" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors">
                我独自升级
              </Link>
              <Link to="/manga/manga-6" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors">
                鬼灭之刃
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors">
                品牌介绍
              </Link>
              <a href="#contact" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors">
                联系我们
              </a>
              <a href="#faq" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors">
                常见问题
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} YY漫画网 - 韩漫日漫国漫大全 | 好看的漫画排行榜推荐 | 免费漫画在线看
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-500 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-500 transition-colors" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}